import styled from '@emotion/styled'

const S = {}

S.Link = styled.li`
  line-height: 0;
  display: flex;
  text-align: start;

  &:last-of-type {
    margin-bottom: 0;
  }

  > * {
    font-size: 0.875rem;
    line-height: 1.125rem;
    transition: color 0.2s ease;
    display: flex;
    align-items: center;
  }

  a,
  [tabindex='0'] {
    cursor: pointer;
    padding: 0.875rem 0.75rem;

    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .icon-before {
    margin-inline-end: 0.625rem;
  }

  .icon-privacychoices {
    margin-inline-start: 0.5rem;
  }

  .icon-upsell {
    margin-inline-end: 0.25rem;
  }

  .icon,
  .icon .logo {
    fill: currentColor;
  }

  .icon {
    flex-shrink: 0;
  }
`

export default S
